import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { createProduct as universalCreateProduct, createProductPlatformized as universalCreateProductPlatformized, createDigitalProduct as universalCreateDigitalProduct, updateProduct as universalUpdateProduct, updateProductPlatformized as universalUpdateProductPlatformized, deleteProduct as universalDeleteProduct, deleteProductPlatformized as universalDeleteProductPlatformized, bulkDeleteProducts as universalBulkDeleteProducts, updateProductVariants as universalUpdateProductVariants, resetAllProductVariantData as universalResetAllProductVariantData, addProductsToCollection as universalAddProductsToCollection, removeProductsFromCollection as universalRemoveProductsFromCollection, addProductMedia as universalAddProductMedia, removeProductMedia as universalRemoveProductMedia, addProductMediaToChoices as universalAddProductMediaToChoices, removeProductMediaFromChoices as universalRemoveProductMediaFromChoices, deleteProductOptions as universalDeleteProductOptions, setCustomFields as universalSetCustomFields, removeCustomFields as universalRemoveCustomFields, removeBrand as universalRemoveBrand, bulkSetCustomFields as universalBulkSetCustomFields, bulkRemoveCustomFields as universalBulkRemoveCustomFields, createCollection as universalCreateCollection, updateCollection as universalUpdateCollection, deleteCollection as universalDeleteCollection, removeRibbon as universalRemoveRibbon, bulkUpdateProductsProperty as universalBulkUpdateProductsProperty, bulkUpdateProductsByFilterSync as universalBulkUpdateProductsByFilterSync, bulkAdjustProductProperty as universalBulkAdjustProductProperty, bulkAdjustProductPropertiesByFilterSync as universalBulkAdjustProductPropertiesByFilterSync, reCloneStore as universalReCloneStore, writeProxyCreateProductPlatformized as universalWriteProxyCreateProductPlatformized, writeProxyUpdateProductPlatformized as universalWriteProxyUpdateProductPlatformized, writeProxyDeleteProductPlatformized as universalWriteProxyDeleteProductPlatformized, queryProductsNonPlatformized as universalQueryProductsNonPlatformized, queryProducts as universalQueryProducts, queryProductsWithBigPageLimit as universalQueryProductsWithBigPageLimit, getProduct as universalGetProduct, getProductPlatformized as universalGetProductPlatformized, queryCollections as universalQueryCollections, getCollection as universalGetCollection, getCollectionBySlug as universalGetCollectionBySlug, getProductOptionsAvailability as universalGetProductOptionsAvailability, queryProductVariants as universalQueryProductVariants, queryStoreVariants as universalQueryStoreVariants, queryStoreVariantsWithBigLimit as universalQueryStoreVariantsWithBigLimit, getStoreVariant as universalGetStoreVariant, aggregateProducts as universalAggregateProducts, } from './stores-catalog-v1-product.universal';
import { ProductType, InventoryStatus, MeasurementUnit, MediaItemType, OptionType, DiscountType, FileType, Version, SortOrder, WebhookIdentityType, } from './stores-catalog-v1-product.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.stores.catalog.v1.product', module_name: 'wix-stores.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        createProduct: (product) => {
            const methodLogData = {
                method_name: 'createProduct',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.createProduct',
            };
            return universalCreateProduct(product, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createProductPlatformized: (product) => {
            const methodLogData = {
                method_name: 'createProductPlatformized',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.createProductPlatformized',
            };
            return universalCreateProductPlatformized(product, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createDigitalProduct: (options) => {
            const methodLogData = {
                method_name: 'createDigitalProduct',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.createDigitalProduct',
            };
            return universalCreateDigitalProduct(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateProduct: (_id, product) => {
            const methodLogData = {
                method_name: 'updateProduct',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.updateProduct',
            };
            return universalUpdateProduct(_id, product, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateProductPlatformized: (_id, product) => {
            const methodLogData = {
                method_name: 'updateProductPlatformized',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.updateProductPlatformized',
            };
            return universalUpdateProductPlatformized(_id, product, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteProduct: (_id) => {
            const methodLogData = {
                method_name: 'deleteProduct',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.deleteProduct',
            };
            return universalDeleteProduct(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteProductPlatformized: (_id) => {
            const methodLogData = {
                method_name: 'deleteProductPlatformized',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.deleteProductPlatformized',
            };
            return universalDeleteProductPlatformized(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkDeleteProducts: (ids) => {
            const methodLogData = {
                method_name: 'bulkDeleteProducts',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.bulkDeleteProducts',
            };
            return universalBulkDeleteProducts(ids, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateProductVariants: (_id, variants) => {
            const methodLogData = {
                method_name: 'updateProductVariants',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.updateProductVariants',
            };
            return universalUpdateProductVariants(_id, variants, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        resetAllProductVariantData: (_id) => {
            const methodLogData = {
                method_name: 'resetAllProductVariantData',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.resetAllProductVariantData',
            };
            return universalResetAllProductVariantData(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        addProductsToCollection: (_id, productIds) => {
            const methodLogData = {
                method_name: 'addProductsToCollection',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.addProductsToCollection',
            };
            return universalAddProductsToCollection(_id, productIds, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeProductsFromCollection: (_id, productIds) => {
            const methodLogData = {
                method_name: 'removeProductsFromCollection',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.removeProductsFromCollection',
            };
            return universalRemoveProductsFromCollection(_id, productIds, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        addProductMedia: (_id, media) => {
            const methodLogData = {
                method_name: 'addProductMedia',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.addProductMedia',
            };
            return universalAddProductMedia(_id, media, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeProductMedia: (_id, mediaIds) => {
            const methodLogData = {
                method_name: 'removeProductMedia',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.removeProductMedia',
            };
            return universalRemoveProductMedia(_id, mediaIds, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        addProductMediaToChoices: (_id, media) => {
            const methodLogData = {
                method_name: 'addProductMediaToChoices',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.addProductMediaToChoices',
            };
            return universalAddProductMediaToChoices(_id, media, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeProductMediaFromChoices: (_id, media) => {
            const methodLogData = {
                method_name: 'removeProductMediaFromChoices',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.removeProductMediaFromChoices',
            };
            return universalRemoveProductMediaFromChoices(_id, media, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteProductOptions: (_id) => {
            const methodLogData = {
                method_name: 'deleteProductOptions',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.deleteProductOptions',
            };
            return universalDeleteProductOptions(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        setCustomFields: (_id, options) => {
            const methodLogData = {
                method_name: 'setCustomFields',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.setCustomFields',
            };
            return universalSetCustomFields(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeCustomFields: (_id, options) => {
            const methodLogData = {
                method_name: 'removeCustomFields',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.removeCustomFields',
            };
            return universalRemoveCustomFields(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeBrand: (_id) => {
            const methodLogData = {
                method_name: 'removeBrand',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.removeBrand',
            };
            return universalRemoveBrand(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkSetCustomFields: (options) => {
            const methodLogData = {
                method_name: 'bulkSetCustomFields',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.bulkSetCustomFields',
            };
            return universalBulkSetCustomFields(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkRemoveCustomFields: (options) => {
            const methodLogData = {
                method_name: 'bulkRemoveCustomFields',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.bulkRemoveCustomFields',
            };
            return universalBulkRemoveCustomFields(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createCollection: (collection) => {
            const methodLogData = {
                method_name: 'createCollection',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.createCollection',
            };
            return universalCreateCollection(collection, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateCollection: (_id, collection) => {
            const methodLogData = {
                method_name: 'updateCollection',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.updateCollection',
            };
            return universalUpdateCollection(_id, collection, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        deleteCollection: (_id) => {
            const methodLogData = {
                method_name: 'deleteCollection',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.deleteCollection',
            };
            return universalDeleteCollection(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        removeRibbon: (_id) => {
            const methodLogData = {
                method_name: 'removeRibbon',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.removeRibbon',
            };
            return universalRemoveRibbon(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateProductsProperty: (ids, set) => {
            const methodLogData = {
                method_name: 'bulkUpdateProductsProperty',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.bulkUpdateProductsProperty',
            };
            return universalBulkUpdateProductsProperty(ids, set, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateProductsByFilterSync: (filter, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateProductsByFilterSync',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.bulkUpdateProductsByFilterSync',
            };
            return universalBulkUpdateProductsByFilterSync(filter, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkAdjustProductProperty: (adjust, ids) => {
            const methodLogData = {
                method_name: 'bulkAdjustProductProperty',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.bulkAdjustProductProperty',
            };
            return universalBulkAdjustProductProperty(adjust, ids, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkAdjustProductPropertiesByFilterSync: (filter, options) => {
            const methodLogData = {
                method_name: 'bulkAdjustProductPropertiesByFilterSync',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.bulkAdjustProductPropertiesByFilterSync',
            };
            return universalBulkAdjustProductPropertiesByFilterSync(filter, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        reCloneStore: (metasiteId, options) => {
            const methodLogData = {
                method_name: 'reCloneStore',
                service_name: 'wix.catalog.api.v1.CatalogWriteApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogWriteApi.reCloneStore',
            };
            return universalReCloneStore(metasiteId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        writeProxyCreateProductPlatformized: (product) => {
            const methodLogData = {
                method_name: 'writeProxyCreateProductPlatformized',
                service_name: 'wix.catalog.write.proxy.v1.CatalogWriteProxy',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.write.proxy.v1.CatalogWriteProxy.writeProxyCreateProductPlatformized',
            };
            return universalWriteProxyCreateProductPlatformized(product, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        writeProxyUpdateProductPlatformized: (_id, product) => {
            const methodLogData = {
                method_name: 'writeProxyUpdateProductPlatformized',
                service_name: 'wix.catalog.write.proxy.v1.CatalogWriteProxy',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.write.proxy.v1.CatalogWriteProxy.writeProxyUpdateProductPlatformized',
            };
            return universalWriteProxyUpdateProductPlatformized(_id, product, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        writeProxyDeleteProductPlatformized: (_id) => {
            const methodLogData = {
                method_name: 'writeProxyDeleteProductPlatformized',
                service_name: 'wix.catalog.write.proxy.v1.CatalogWriteProxy',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.write.proxy.v1.CatalogWriteProxy.writeProxyDeleteProductPlatformized',
            };
            return universalWriteProxyDeleteProductPlatformized(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryProductsNonPlatformized: (options) => {
            const methodLogData = {
                method_name: 'queryProductsNonPlatformized',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.queryProductsNonPlatformized',
            };
            return universalQueryProductsNonPlatformized(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryProducts: () => {
            const methodLogData = {
                method_name: 'queryProducts',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.queryProducts',
            };
            return universalQueryProducts(
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryProductsWithBigPageLimit: (options) => {
            const methodLogData = {
                method_name: 'queryProductsWithBigPageLimit',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.queryProductsWithBigPageLimit',
            };
            return universalQueryProductsWithBigPageLimit(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getProduct: (_id, options) => {
            const methodLogData = {
                method_name: 'getProduct',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.getProduct',
            };
            return universalGetProduct(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getProductPlatformized: (_id, options) => {
            const methodLogData = {
                method_name: 'getProductPlatformized',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.getProductPlatformized',
            };
            return universalGetProductPlatformized(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryCollections: (options) => {
            const methodLogData = {
                method_name: 'queryCollections',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.queryCollections',
            };
            return universalQueryCollections(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getCollection: (_id, options) => {
            const methodLogData = {
                method_name: 'getCollection',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.getCollection',
            };
            return universalGetCollection(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getCollectionBySlug: (slug) => {
            const methodLogData = {
                method_name: 'getCollectionBySlug',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.getCollectionBySlug',
            };
            return universalGetCollectionBySlug(slug, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getProductOptionsAvailability: (_id, options) => {
            const methodLogData = {
                method_name: 'getProductOptionsAvailability',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.getProductOptionsAvailability',
            };
            return universalGetProductOptionsAvailability(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryProductVariants: (_id, options) => {
            const methodLogData = {
                method_name: 'queryProductVariants',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.queryProductVariants',
            };
            return universalQueryProductVariants(_id, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryStoreVariants: (query, options) => {
            const methodLogData = {
                method_name: 'queryStoreVariants',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.queryStoreVariants',
            };
            return universalQueryStoreVariants(query, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryStoreVariantsWithBigLimit: (options) => {
            const methodLogData = {
                method_name: 'queryStoreVariantsWithBigLimit',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.queryStoreVariantsWithBigLimit',
            };
            return universalQueryStoreVariantsWithBigLimit(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getStoreVariant: (_id) => {
            const methodLogData = {
                method_name: 'getStoreVariant',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.getStoreVariant',
            };
            return universalGetStoreVariant(_id, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        aggregateProducts: (options) => {
            const methodLogData = {
                method_name: 'aggregateProducts',
                service_name: 'wix.catalog.api.v1.CatalogReadApi',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-stores.v2,entity=wix.stores.catalog.v1.product,environment=velo-frontend,method-fqn=wix.catalog.api.v1.CatalogReadApi.aggregateProducts',
            };
            return universalAggregateProducts(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        ProductType,
        InventoryStatus,
        MeasurementUnit,
        MediaItemType,
        OptionType,
        DiscountType,
        FileType,
        Version,
        SortOrder,
        WebhookIdentityType,
    };
}
//# sourceMappingURL=stores-catalog-v1-product.frontend.js.map